import { FeatureLogger } from '../../utils/feature-logger';

const name = 'traits';

export const logger = new FeatureLogger(name);
